import { render, staticRenderFns } from "./MlbbTeamResultBlock.vue?vue&type=template&id=68ff29ec&scoped=true"
import script from "./MlbbTeamResultBlock.vue?vue&type=script&lang=js"
export * from "./MlbbTeamResultBlock.vue?vue&type=script&lang=js"
import style0 from "./MlbbTeamResultBlock.vue?vue&type=style&index=0&id=68ff29ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff29ec",
  null
  
)

export default component.exports